import BarWidth from '@common-components/graphs/bar-width-graph/BarWidth'
import React from 'react'
import {  useParams, useSearchParams } from 'react-router-dom';
export default function BarwidthGraph() {

    const params = useParams()

    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchID");
    const startDate = searchParams.get("startDate");
    const endDate = searchParams.get("endDate");
    const filter = searchParams.get("filter"); 

  return (
    <div className='mt-10'>
       <BarWidth supplierID={params.id} type = "full" batchId= {batchId} sDate={startDate} eDate={endDate} filter={filter} />   
    </div>
  )
}
